import * as React from "react";
import classnames from "classnames";
import { Text } from "@grandvisionhq/elements";
const PriceDisclaimer = ({ text }) => /* @__PURE__ */ React.createElement("div", { className: classnames("price-disclaimer") }, /* @__PURE__ */ React.createElement(Text, { variant: "caption", color: "text-secondary" }, text));
export {
  PriceDisclaimer
};
//# sourceMappingURL=PriceDisclaimer.js.map
